// extracted by mini-css-extract-plugin
export default {"companyContainer":"fO-z","companyImage":"gO-z","container":"hO-z","heading":"iO-z","darkText":"jO-z","smallHeading":"kO-z","darkBackground":"lO-z","whiteBackground":"mO-z"};